/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'

/* ++++++++++ --------------- EXPORT : TRENDING NOW V2 CONFIGURATION GENERAL SECTION - SORT CONFIG : STYLES --------------- ++++++++++ */
export default theme => ({
  articlelayout: {
    '& .loadmoreupdates': {
      paddingLeft: pxToEm(24),
      borderLeft: '2px solid #ccd1e6'
    },
    '& .incdecfield .field': {
      zIndex: 0
    },
    '& .previewconfig': {
      '& .content': {
        '& > div': {
          maxWidth: pxToEm(400),
        },
        '& .articlecard': {
          width: 'calc(100% - 8px)',
          minWidth: ' calc(100% - 8px)',
        },
        '& .container': {
          maxWidth: pxToEm(400),
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          rowGap: pxToEm(8),
          '& .articlecard': {
            height: '148px'
          }
        },
        '& .loadmore': {
          display: 'flex',
          width: pxToEm(180),
          height: pxToEm(40),
          padding: `${pxToEm(16)} 0`,
          justifyContent: 'center',
          alignItems: 'center',
          background: '#000',
          color: '#FFF',
          borderRadius: pxToEm(30),
          fontSize: pxToEm(14)
        },
        '& h3': {
          fontFamily: '"Source Serif Pro", Georgia, serif',
          paddingBottom: pxToEm(8),
          borderBottom: '3px solid #000'
        },
        '& svg': {
          position: 'relative'
        },
        '& .arrowwrap': {
          position: 'relative',
          width: 0,
          '& svg': {
            position: 'relative',
            height: pxToEm(30),
            width: pxToEm(30)
          }
        },
        '& .leftarrow': {
          top: pxToEm(-24),
          left: pxToEm(-16)
        },
        '& .rightarrow': {
          top: pxToEm(-24),
          left: pxToEm(-24)
        }
      }
    }
  }
});
